import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-to-reorder a list. On drop, PATCHes the new order (array of ids read
// from each item's data-sortable-id) to the given url.
//
//   <ul data-controller="sortable"
//       data-sortable-url-value="/admin/tags/reorder"
//       data-sortable-handle-value=".handle"
//       data-sortable-group-value="tags">
//     <li data-sortable-id="1">…</li>
//   </ul>
//
// `group` should be unique per list. It is a closed group (no pull/put), which
// keeps nested sortable lists from reacting to each other's drags.
export default class extends Controller {
  static values = { url: String, handle: String, group: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.hasHandleValue ? this.handleValue : null,
      group: this.hasGroupValue ? { name: this.groupValue, pull: false, put: false } : null,
      draggable: "[data-sortable-id]",
      swapThreshold: 0.65,
      animation: 150,
      onEnd: () => this.persist()
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  persist() {
    // Only direct children — so a nested sortable list doesn't leak its ids
    // into this one's order.
    const ids = Array.from(this.element.querySelectorAll(":scope > [data-sortable-id]"))
      .map((el) => el.dataset.sortableId)

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ ids })
    })
  }
}
